import React, {useState} from "react";
import {FaChevronDown, FaPhone} from "react-icons/fa";
import {t} from "i18next";
import {EmergencyContact} from "../../models/emergencyContact";

interface EmergencyContactViewProps {
    emergencyContact: EmergencyContact;
}

function EmergencyContactView({emergencyContact}: EmergencyContactViewProps) {
    const [open, setOpen] = useState(false);
    return (
        <div className="view-emergency-contact-container">
            {/* Header */}
            <div className="view-header" onClick={() => setOpen(!open)}>
                {/*<div className="med-view-header-spacer" />*/}
                <h4 className="view-title">{emergencyContact.lastName}, {emergencyContact.firstName}</h4>
                <FaChevronDown className={`view-arrow ${open ? "open" : ""}`}/>
            </div>

            {/* Inhalt */}
            {open && (
                <div className="view-content">
                    <div className="view-field">
                        <span className="label">{t("contact.fields.details")}</span>
                        <span className="value">{emergencyContact.details}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("contact.fields.phone")}</span>

                        <div className="view-phone-list">
                            {emergencyContact.phoneNumbers.length > 0 ? (
                                emergencyContact.phoneNumbers.map((p) => (
                                    <div key={p.id} className="view-phone-row">
                                        <span className="value">
                                            {p.countryCode} {p.phoneNumber}
                                        </span>
                                        <a
                                            href={`tel:${p.countryCode}${p.phoneNumber}`}
                                            className="view-call-button"
                                            title={t("contact.fields.call")}
                                        >
                                            <FaPhone className="view-call-icon"/>
                                        </a>
                                    </div>
                                ))
                            ) : (
                                <span className="value">–</span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EmergencyContactView;